import { render, staticRenderFns } from "./activityResults.vue?vue&type=template&id=6881b545"
import script from "./activityResults.vue?vue&type=script&lang=js"
export * from "./activityResults.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports